import { render, staticRenderFns } from "./DefaultPortfolioDashboard.vue?vue&type=template&id=37736c6b&scoped=true&"
import script from "./DefaultPortfolioDashboard.vue?vue&type=script&lang=js&"
export * from "./DefaultPortfolioDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPortfolioDashboard.vue?vue&type=style&index=0&id=37736c6b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37736c6b",
  null
  
)

export default component.exports